import { render, staticRenderFns } from "./IconSvgLegislative.vue?vue&type=template&id=bd052dbe&scoped=true&"
import script from "./IconSvgLegislative.vue?vue&type=script&lang=js&"
export * from "./IconSvgLegislative.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd052dbe",
  null
  
)

export default component.exports